var _circle, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstitutionInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 47,
    fill: "#8ECDD6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3163_22847)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 39,
    fill: "#73A6AD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0214 34.1992L35.5214 41.6992C34.4277 42.168 33.8183 43.3398 34.0605 44.4961C34.3027 45.6523 35.3183 46.4961 36.5058 46.4961V47.1211C36.5058 48.1602 37.3417 48.9961 38.3808 48.9961H69.6308C70.6698 48.9961 71.5058 48.1602 71.5058 47.1211V46.4961C72.6933 46.4961 73.7167 45.6602 73.9511 44.4961C74.1855 43.332 73.5761 42.1602 72.4902 41.6992L54.9902 34.1992C54.3573 33.9336 53.6464 33.9336 53.0214 34.1992ZM44.0058 51.4961H39.0058V66.832C38.9589 66.8555 38.912 66.8867 38.8652 66.918L35.1152 69.418C34.2011 70.0273 33.787 71.168 34.1074 72.2227C34.4277 73.2773 35.4042 73.9961 36.5058 73.9961H71.5058C72.6073 73.9961 73.5761 73.2773 73.8964 72.2227C74.2167 71.168 73.8105 70.0273 72.8886 69.418L69.1386 66.918C69.0917 66.8867 69.0448 66.8633 68.998 66.832V51.4961H64.0058V66.4961H60.8808V51.4961H55.8808V66.4961H52.1308V51.4961H47.1308V66.4961H44.0058V51.4961ZM54.0058 38.9961C54.6688 38.9961 55.3047 39.2595 55.7736 39.7283C56.2424 40.1972 56.5058 40.8331 56.5058 41.4961C56.5058 42.1591 56.2424 42.795 55.7736 43.2639C55.3047 43.7327 54.6688 43.9961 54.0058 43.9961C53.3427 43.9961 52.7069 43.7327 52.238 43.2639C51.7692 42.795 51.5058 42.1591 51.5058 41.4961C51.5058 40.8331 51.7692 40.1972 52.238 39.7283C52.7069 39.2595 53.3427 38.9961 54.0058 38.9961Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3163_22847",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_3163_22847"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionInCircle);
export default __webpack_public_path__ + "static/media/institution-in-circle.7ec8d2ad22cdf677f31b26ccd9582d02.svg";
export { ForwardRef as ReactComponent };